export default __webpack_public_path__ + "static/char-v-11-bcf685944581521cdf41b5aa958137f6.png";